import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'basic-confirmation',
  templateUrl: './basic-confirmation.component.html',
  styleUrls: ['./basic-confirmation.component.css']
})
export class BasicConfirmationComponent implements AfterViewInit {
  @Input()
  title: string = "";
  @Input()
  content: string = "";
  
  constructor(public activeModal: NgbActiveModal) {
  }
  ngAfterViewInit(): void {
  }
}